/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
(function( $ ) {
    "use strict";

}( jQuery ) );
